module.exports = __webpack_public_path__ + "img/map_location.dba6683c.png";